import DeviationMediaService, { fallbackToLargestFile } from '../../../../utils/DeviationMediaService';
import ddt from '@wix/da-ddt';
import { isValidFileSrc } from '../../../../DeviationViews/_helpers';
export const getImageStylesAndSrc = (deviation, propsWidth, config, containerWidth)=>{
    ddt.log('measuredhook', 'Image - container width', {
        containerWidth
    });
    const fullview = DeviationMediaService.getLargestFullview(deviation);
    if (!fullview) {
        ddt.log('Editor', 'Not rendering mono image - no fullview', deviation);
        return false;
    }
    // Calculate the width and height of the block
    const fvImageRatio = (fullview.width || 0) / (fullview.height || 0);
    const coverWidth = propsWidth === 'static' ? 780 : propsWidth || 780;
    const coverHeight = coverWidth / fvImageRatio;
    const coverThumb = DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, coverWidth, coverHeight, fallbackToLargestFile, {
        allowFullview: true,
        allowPreview: true
    });
    if (!coverThumb || !isValidFileSrc(coverThumb.src)) {
        ddt.log('Editor', 'Not rendering mono image', deviation);
        return false;
    }
    // Dont stretch things - max is the fullview width
    // we then let browser decide whats best using srcset
    let imgWidth = '100%';
    if (!propsWidth || (fullview.width || 0) < Number(propsWidth)) {
        imgWidth = fullview.width;
    }
    let wrapperStyles = {};
    if (propsWidth !== 'static') {
        const actualWidth = propsWidth || containerWidth;
        // Dont over pad small images
        let boundHeight = actualWidth / fvImageRatio;
        if (fullview.height && boundHeight > fullview.height) {
            boundHeight = fullview.height;
        }
        ddt.log('measuredhook', 'Image size', {
            actualWidth,
            propsWidth,
            containerWidth,
            boundHeight,
            fvImageRatio,
            fvHeight: fullview.height
        });
        wrapperStyles = {
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            width: actualWidth || '100%',
            height: `${boundHeight}px`
        };
    }
    let imgStyles = {};
    if (propsWidth !== 'static') {
        imgStyles = {
            width: imgWidth,
            maxWidth: '100%',
            display: 'block' /* fixes wrappers not being correct height */ 
        };
    }
    const allowFullview = (fullview.width || 0) > (Number(propsWidth) || 0);
    const canBeLinked = config.link || deviation.isPublished;
    return {
        allowFullview,
        canBeLinked,
        imgStyles,
        wrapperStyles,
        coverThumb,
        fullview
    };
};

//# sourceMappingURL=helpers.js.map